<div *ngIf="isLoading | async" class="overlay">
  <mat-progress-spinner class="spinner" [diameter]="48" [color]="color" [mode]="mode" [value]="value">
  </mat-progress-spinner>
</div>